import moment from 'moment';

export const formatTime = date => moment(date, 'hh:mm:ss').format('h:mma');
